export enum AssemblerManagementOption {
  ConfirmAssembly = 1,
  ManageOrder = 2,
  
  InformReceipt = 7,
  InformAssemblyStart = 8,
  InformCompletedAssembly = 9,
  InformSendToStore = 10,

  AddNote = 11,
  PrintTSO = 12
}